import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { ContentPromotionFormResponse } from "@/types/models/ContentPromotionFormResponse.interface";

const useLazyContentPromotionFormResponsesGet = (formId: string) => {
  const requestUrl = `${API_BASE_URL}/api/v3/platform-alignment-form-response/?form_id=${formId}`;
  return useLazyRestQuery(requestUrl, { skip: !formId }) as [
    () => void,
    {
      data: ContentPromotionFormResponse[] | undefined;
      error: Error;
      loading: boolean;
    },
  ];
};

export default useLazyContentPromotionFormResponsesGet;
